<template>
  <div class="learingTikuRandom">
    <backHeader back-addr="/indexKaoyan"></backHeader>
    <div>
                <br />
                <div v-show="tikuListShow">
                  <div @click="closeTikuList()" style="width:100%;text-align:center;">X</div>
                  <div class="flex-container" >
                  
                  <div v-for="(item,index) in list">
                    <a @click="goChooseTiku(item,index)" v-if="item.answerSituation==2" class="right">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else-if="item.answerSituation==1" class="wrong">{{index+1}}</a>
                    <a @click="goChooseTiku(item,index)" v-else class="notAnswer">{{index+1}}</a>
                  </div>
                  
                  <!-- <a @click="goChooseTiku(item,index)" v-for="(item,index) in list">{{index+1}}</a> -->
                </div>
                </div>
                <div style="padding-left:10px;padding-right:10px;border-bottom:1px solid #BBBBBB;" v-show="!tikuListShow">
                            <div style="display:flex;text-align:center;">
                                <div style="flex:1;text-align:left;">
                                  <mt-badge size="small" color="#888">{{showType(tiku.type)}}</mt-badge>
                                    <!-- <span class="mui-badge" style="font-size:0.8rem;">{{showType(tiku.type)}}</span> -->
                                </div>
                                <div style="flex:1;">
                                    <span style="font-size:0.8rem;" @click="goTikuList">{{answerCount+1}}/{{totalCount}}</span>
                                </div>
                                <div style="flex:1;text-align:right;">
                                    <!-- <img class="mui-media-object mui-pull-left" :src="collection" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
                                    <span style="font-size:0.8rem;">收藏</span> -->
                                    <CollectElement v-bind:collect-data="tiku" v-bind:collect-state="tiku.collectionType" v-bind:collect-id="tiku.id" v-bind:collect-type="'tikuCollect'"></CollectElement>
                                </div>
                            </div>
                            <br />
                            <div class="mui-row">
                                <div class="mui-col-sm-12 mui-col-xs-12">
                                    <span style="font-size:16px;">{{tiku.content}}：</span>
                                </div>
                            </div>
                            <br />


                            <mt-checklist v-model="answerCheckBoxArr" :options="options">
                            </mt-checklist>
                            <!-- <span>{{answerCheckBoxArr}}</span> -->


                            <div class="mui-row" style="display:flex">
                                    <!-- <button style="flex:1" type="button" class="mui-btn mui-btn-danger mui-btn-outlined" @click="submitTiku()" v-show="tiku.answerAble == true">确定</button> -->
                                    <mt-button style="flex:1" plain type="danger" @click="submitTiku()" v-show="tiku.answerAble == true">确定</mt-button>
                            </div>

                            
                            <br />
                            <div class="mui-row" v-show="tiku.showAnswerStatus">
                                <div class="mui-col-sm-12 mui-col-xs-12">
                                    <span v-if="tiku.answerSituation==1" style="color:red;">错误</span>
                                    <span v-if="tiku.answerSituation==2" style="color:green;">正确</span>
                                    <span style="font-size:0.8rem;">正确答案为:{{tiku.answer}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="mui-row" v-show="tiku.showAnswerStatus">
                                <div class="mui-col-sm-12 mui-col-xs-12">
                                    <span style="font-size:0.8rem;">解析:{{tiku.tip}}</span>
                                </div>
                            </div>
                            <br v-show="tiku.showAnswerStatus" />
                            <div class="mui-row" style="display:flex">
                                    <mt-button style="flex:1" plain type="danger" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</mt-button>
                                    <mt-button style="flex:1" plain type="danger" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</mt-button>
                                    <!-- <button style="flex:1" type="button" class="mui-btn mui-btn-danger mui-btn-outlined" v-if="this.answerCount!=0" @click="showPrevTiku()">上一题</button>
                                    <button style="flex:1" type="button" class="mui-btn mui-btn-danger mui-btn-outlined" v-if="this.answerCount<this.totalCount-1" @click="showNextTiku()">下一题</button> -->
                            </div>
                       
                            
                        </div>
                
            </div>
            <div style="height:60px;"></div>
            </div>
  </div>
</template>
<script>
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import CollectElement from "@/components/collect";
import { Toast, MessageBox } from "mint-ui";
import backHeader from "./../components/back-header.vue";

export default {
  name: "learingClass",
  data() {
    return {
      answerCheckBoxArr: [],
      //checklist设置
      options: [],
      tikuInfo: {
        rightNum: 0, //答对题目数
        wrongNum: 0, //答错题目数
        notAnswerNum: 0, //未答题目数
        randomId: 0 //随机答题答道哪个id的题目了
      },
      //本地缓存的答题情况
      localTikuAnswerSituation: null,
      //是否显示题目列表
      tikuListShow: false,
      // //是否显示答案
      // showAnswerStatus: false,
      //答案字符串
      answerString: "",

      // collection: collection,
      list: [
        {
          answerAble: true,
          answer: "A",
          four: "加载中",
          one: "加载中",
          tip: "无",
          id: 6,
          type: 1,
          two: "加载中",
          three: "加载中",
          content: "加载中"
        }
      ],
      totalCount: 3,
      answerCount: 0,
      tempTiku: "",
      //当前题目
      tiku: {
        answerAble: true,
        answer: "A",
        four: "加载中",
        one: "加载中",
        tip: "无",
        id: 6,
        type: 1,
        two: "加载中",
        three: "加载中",
        content: "加载中"
      },
      //上一道题目
      prevTiku: ""
    };
  },
  methods: {
    goChooseTiku(item, index) {
      //关闭题目列表
      this.tikuListShow = false;
      //题目等于item
      this.tiku = item;
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      //为了answerCheckBoxArr不刷新，借一手
      this.$nextTick(() => {
        this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
      });
      //获取该题目的序号
      this.answerCount = index;
      //关闭答案
      //this.showAnswerStatus = false;
    },
    closeTikuList() {
      this.tikuListShow = false;
    },
    goTikuList() {
      console.log("go tiku list");
      this.tikuListShow = true;
    },

    submitTiku() {
      var count = this.answerCheckBoxArr.length;

      this.answerString = this.answerCheckBoxArr.join(",");
      if (this.tiku.type == 1 && count > 1) {
        MessageBox.alert("单选题只能选择一个答案！", "提示");
        return;
      }
      if (count == 0) {
        MessageBox.alert("至少选择一个答案！", "提示");
        return;
      }
      if (this.tiku.type == 2 && count < 2) {
        MessageBox.alert("多选题最少选择二个答案！", "提示");
        return;
      }

      this.$nextTick(() => {
        //设置已经答题问题的信息
        this.list[this.answerCount].answerCheckBoxArr = this.answerCheckBoxArr;
        this.list[this.answerCount].answerAble = false;
        this.tiku.answerAble = false;
        this.tiku.showAnswerStatus = true;
        this.list[this.answerCount].showAnswerStatus = true;

        console.log("tick list is:");
        console.log(this.list[this.answerCount]);
        console.log("tiku tiku is:");
        console.log(this.tiku);
      });

      console.log("answerString is:");
      console.log(this.answerString);
      if (this.answerString == this.tiku.answer) {
        //this.showAnswerStatus = true;

        MessageBox.alert("回答正确！", "提示");
        //this.list[this.answerCount].answerRight=true;
        //将答对的信息设置一下*********
        this.list[this.answerCount].answerSituation = 2;
        // console.log("list is:");
        // console.log(this.list);

        return;
      } else {
        //this.showAnswerStatus = true;

        MessageBox.alert("回答错误！", "提示");
        //this.list[this.answerCount].answerRight=false;
        //将答错的信息设置一下*********
        this.list[this.answerCount].answerSituation = 1;
        // console.log("list is:");
        // console.log(this.list);

        //   //将错误题目写入redis数据库
        //   var redisKey = this.$store.state.appData.userId + "-" + "tikuWrong";
        //   var redisValue = this.tiku.id;
        //   axios
        //     .post(
        //       getGoAPIPrefix() + "user/collect",
        //       Qs.stringify({
        //         key: redisKey,
        //         value: redisValue,
        //         operation: 1
        //       })
        //     )
        //     .then(res => {
        //       if (res.data.returnCode == 100) {
        //         console.log("collect success");
        //         console.log("userId is:");
        //         console.log(res.data.returnData);
        //       }
        //     })
        //     .catch(err => {
        //       mui.toast("收藏功能异常！");
        //       console.log("collect failed");
        //       console.log(err);
        //     });
        //   return;
        // }
      }
    },
    showPrevTiku() {
      //this.showAnswerStatus = false;
      if (this.answerCount > 1) {
        this.answerCount--;
        this.prevTiku = this.list[this.answerCount];
        this.tiku = this.list[this.answerCount];
        this.options = [
          {
            label: this.tiku.one,
            value: "A"
          },
          {
            label: this.tiku.two,
            value: "B"
          },
          {
            label: this.tiku.three,
            value: "C"
          },
          {
            label: this.tiku.four,
            value: "D"
          }
        ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(() => {
          this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
        });
      } else if (this.answerCount == 1) {
        this.answerCount--;
        this.tiku = this.list[0];
        this.options = [
          {
            label: this.tiku.one,
            value: "A"
          },
          {
            label: this.tiku.two,
            value: "B"
          },
          {
            label: this.tiku.three,
            value: "C"
          },
          {
            label: this.tiku.four,
            value: "D"
          }
        ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(() => {
          this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
        });
        this.prevTiku = "";
      } else {
        console.log("已经是最开始了");
      }
    },
    showNextTiku() {
      //this.showAnswerStatus = false;
      this.randomGetTiku();
    },
    //初始化随机取出一个题目
    initRandomTiku() {
      //this.tiku=this.list[0];
      //根据上次打开的位置跳转
      this.tiku = this.list[this.tikuInfo.randomId];
      this.options = [
        {
          label: this.tiku.one,
          value: "A"
        },
        {
          label: this.tiku.two,
          value: "B"
        },
        {
          label: this.tiku.three,
          value: "C"
        },
        {
          label: this.tiku.four,
          value: "D"
        }
      ];
      this.answerCount = this.tikuInfo.randomId;
      console.log("this tiku is:", this.tiku);
      this.prevTiku = "";
    },
    //取出一个题目
    randomGetTiku() {
      if (this.answerCount < this.list.length - 1) {
        this.prevTiku = this.tiku;
        this.answerCount++;
        this.tiku = this.list[this.answerCount];
        this.options = [
          {
            label: this.tiku.one,
            value: "A"
          },
          {
            label: this.tiku.two,
            value: "B"
          },
          {
            label: this.tiku.three,
            value: "C"
          },
          {
            label: this.tiku.four,
            value: "D"
          }
        ];
        //为了answerCheckBoxArr不刷新，借一手
        this.$nextTick(() => {
          this.answerCheckBoxArr = this.tiku.answerCheckBoxArr;
        });
      } else {
        console.log("已经答完题目");
      }
    },
    showType: function(cellValue) {
      if (cellValue == "1") {
        return "单选";
      } else if (cellValue == "2") {
        return "多选";
      }
    },
    initTikuData() {
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "tiku/listTiku?pageNum=1&pageRow=1000&id=" +
            this.$store.state.mineStore.userId
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //设置相关默认值
            for (var j = 0; j < res.data.returnData.list.length; j++) {
              //默认为未答状态
              res.data.returnData.list[j].answerSituation = -1;
              //默认为全部未勾选的状态
              res.data.returnData.list[j].answerAble = true;

              res.data.returnData.list[j].answerCheckBoxArr = [];
              res.data.returnData.list[j].showAnswerStatus = false;
              //res.data.returnData.list[j].answerRight=null;
            }

            //初始化赋值题目列表，以及题目总数，还有随机抽取出第一道题目
            this.list = res.data.returnData.list;
            //题目放入缓存中
            //localStorage.setItem("tiku",this.list);
            console.log("this list is:", this.list);
            // //默认设置收藏状态
            // this.list.forEach(function(value, index, array) {
            //   array[index].collectionType = false;
            // });
            this.totalCount = this.list.length;
            //将list中的数据与缓存中的答题情况进行融合，也就是给list中每个元素加上answerSituation
            this.initLocalCacheData();
            //0621
            this.initRandomTiku();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    initLocalCacheData() {
      if (
        localStorage.getItem("tikuInfo") === null ||
        localStorage.getItem("tikuInfo") === undefined
      ) {
      } else {
        this.tikuInfo = JSON.parse(localStorage.getItem("tikuInfo"));
      }
      if (
        localStorage.getItem("tikuAnswerSituation") === null ||
        localStorage.getItem("tikuAnswerSituation") === undefined
      ) {
        return;
      }
      //记录答题情况 答对为2 答错为1 未答为-1
      this.localTikuAnswerSituation = JSON.parse(
        localStorage.getItem("tikuAnswerSituation")
      );
      // console.log("localTikuAnswerSituation is:");
      // console.log(this.localTikuAnswerSituation[1]);
      var localLen = this.localTikuAnswerSituation.length;
      var Len = this.list.length;
      //循环获取最新list中题目的情况
      for (var j = 0; j < Len; j++) {
        //查找是否有本地答题状态的记录
        for (var i = 0; i < localLen; i++) {
          // console.log("id1 is:");
          // console.log(this.localTikuAnswerSituation[i].id);
          // console.log("id2 is:");
          // console.log(this.list[j].id);
          //如果id相等，且answerSituation不为空的情况下
          if (
            this.localTikuAnswerSituation[i].id == this.list[j].id &&
            this.localTikuAnswerSituation[i].answerSituation
          ) {
            this.list[j].answerSituation = this.localTikuAnswerSituation[
              i
            ].answerSituation;
            continue;
          }
        }
      }
    }
  },
  mounted: function() {},
  beforeDestroy() {
    console.log("beforeDestroy");

    this.tikuInfo = {
      rightNum: 0, //答对题目数
      wrongNum: 0, //答错题目数
      notAnswerNum: 0, //未答题目数
      randomId: 0 //随机答题答道哪个id的题目了
    };

    for (var i = 0; i < this.list.length; i++) {
      //默认为全部未勾选的状态
      this.list[i].answerAble = true;

      this.list[i].answerCheckBoxArr = [];
      this.list[i].showAnswerStatus = false;

      if (this.list[i].answerSituation == 2) {
        this.tikuInfo.rightNum++;
      }
      if (this.list[i].answerSituation == 1) {
        this.tikuInfo.wrongNum++;
      }
      if (this.list[i].answerSituation == -1) {
        this.tikuInfo.notAnswerNum++;
      }
    } //for
    //this.tikuInfo.randomId=this.list[this.answerCount].id;
    this.tikuInfo.randomId = this.answerCount;
    localStorage.setItem("tikuInfo", JSON.stringify(this.tikuInfo));
    localStorage.setItem("tikuAnswerSituation", JSON.stringify(this.list));
  },
  created() {
    this.initTikuData();
  },
  components: {
    CollectElement,
    backHeader
  }
};
</script>

<style lang="scss"  scoped>
@import "../assets/baseScss";
.mint-checklist-label {
  display: flex !important;
}
.mint-checkbox {
  flex: 1 !important;
}
.mint-checkbox-label {
  flex: 1 !important;
}
#about-img {
  width: 100%;
}

p {
  margin-left: 15px;
  margin-right: 15px;
}

.mui-input-group .mui-input-row {
  height: auto;
}

.flex-container {
  /* display: -webkit-box;
  display: -webkit-flex; */
  display: flex;
  flex-wrap: wrap;
  /* -webkit-flex-flow: row wrap; */
  /* justify-content: space-between; */
  /* text-align: center; */
  /* height: 700px; */
}

.flex-container div {
  flex: 1;
  margin: 3px;
  width: 40px;
  height: 40px;
  display: inline-block;
  text-align: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 25px;
  background-clip: padding-box;
  min-width: 12%;
  max-width: 12%;
  vertical-align: center;
  line-height: 40px;
}

.wrong {
  color: red;
}

.right {
  color: green;
}

.notAnswer {
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/module-tiku/tikuRandom.vue